// v1.0.0 - 2026-01-28 - Settings page placeholder

import { PageContainer, PageHeader } from '@/components/layout/PageContainer'
import { Card, CardContent } from '@/components/ui/card'

export default function SettingsPage() {
  return (
    <PageContainer>
      <PageHeader
        title="Impostazioni"
        description="Configurazione CER e branding"
      />
      <Card>
        <CardContent className="py-12 text-center text-[var(--color-text-secondary)]">
          Impostazioni in arrivo (Sprint 6)
        </CardContent>
      </Card>
    </PageContainer>
  )
}
